/**
 * Parse query params
 * @module
 */

var _ = require('optimizely-client-fn');
var WindowEnv = require('../env/window');

/**
 * @return {Array} [['foo', 'val1'], ['foo2', 'val2'], ['foo3', 'val3']]
 */
exports.getQueryParams = function(): string[][] {
  var queryString = WindowEnv.getLocationSearch() || '';
  if (queryString.indexOf('?') === 0) {
    queryString = queryString.substring(1);
  }
  if (queryString.length === 0) {
    return [];
  }

  var query = queryString.split('&');
  var nameValuePairs = [];
  for (var i = 0; i < query.length; i++) {
    // Pull out the name, value pair
    var name = '';
    var value = '';
    var nameAndValue = query[i].split('=');
    if (nameAndValue.length > 0) {
      name = nameAndValue[0];
    }
    if (nameAndValue.length > 1) {
      value = nameAndValue[1];
    }
    nameValuePairs.push([name, value]);
  }
  return nameValuePairs;
};

/**
 * Get the value of a specific query param by name.
 * @param {string} name
 * @returns {string|undefined}
 */
exports.getQueryParamValue = function(name:string): string|undefined {
  var params = exports.getQueryParams();
  for (var i = 0; i < params.length; i++) {
    if (params[i][0] === name) {
      return params[i][1];
    }
  }
  return undefined;
};

/**
 * Get the query string for a given set of params
 * @param {Object.<string>} params
 * @returns {string}
 */
exports.queryStringFromMap = function(params:Record<string, string>): string {
  return _.map(params, function(paramValue, paramName) {
    return paramName + '=' + paramValue;
  }).join('&');
};
